import { render } from "./contact-bank.vue?vue&type=template&id=2ac3f17a&scoped=true&ts=true"
import script from "./contact-bank.vue?vue&type=script&lang=ts"
export * from "./contact-bank.vue?vue&type=script&lang=ts"

import "./contact-bank.vue?vue&type=style&index=0&id=2ac3f17a&lang=less&scoped=true"
import "./contact-bank.vue?vue&type=style&index=1&id=2ac3f17a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac3f17a"]])

export default __exports__